import React, { useCallback, useEffect, useState } from 'react';
import { getWarrantyPeriods } from 'services/warranty-period.service';
import WarrantyPeriodFilter from './components/WarrantyPeriodFilter';
import WarrantyPeriodTable from './components/WarrantyPeriodTable';

const WarrantyPeriodPage = () => {
  const [params, setParams] = useState({ is_active: 1, page: 1, itemsPerPage: 25 });
  const [data, setData] = useState({ items: [], page: 1, itemsPerPage: 25, totalItems: 0, totalPages: 0 });
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(() => {
    setLoading(true);
    getWarrantyPeriods(params)
      .then(setData)
      .finally(() => setLoading(false));
  }, [params]);

  useEffect(loadData, [loadData]);

  return (
    <div className='bw_main_wrapp'>
      <WarrantyPeriodFilter
        onChange={(values) => setParams((current) => ({ ...current, ...values, page: 1 }))}
      />
      <WarrantyPeriodTable
        loading={loading}
        data={data.items}
        page={data.page}
        itemsPerPage={data.itemsPerPage}
        totalItems={data.totalItems}
        totalPages={data.totalPages}
        onChangePage={(page) => setParams((current) => ({ ...current, page }))}
        onRefresh={loadData}
      />
    </div>
  );
};

export default WarrantyPeriodPage;
